import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AuthorizationGuardService implements CanActivate {
	readonly #authService = inject(AuthService);
	readonly #router = inject(Router);

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

		const requiredRoles = route.data['roles'] as Array<string>;
		const userRoles = this.#authService.userLoggedValue?.Roles ?? [];

		const hasPermission = !requiredRoles?.length || requiredRoles.some(r => userRoles.includes(r));

		if (!hasPermission) {
			return this.#router.createUrlTree(['/error/forbidden']);
		}

		return true;
	}
}
